require('./contractEasyLoanTypeCView.scss');

const PropTypes = require('prop-types');

//@vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require("react-router-dom");
//@actions
const blockedAccountsActions = require('actions/blockedAccounts');
const contractEasyLoanTypeC = require('../../actions/contractEasyLoanTypeC');
const segmentedLoanActions = require('../../actions/segmentedLoanProducts');
const contractInit = require('../../actions/commons/contractInit');
const { getLoanRecordStatus, cancelLoanRecord } = require('../../actions/loanRecordStatus');
//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const { CallMeBack } = require('components/callMeBack/callMeBack');
//@core
const { formatText, getFinalTitle } = require('core/i18n').i18n;
//@components
const ContractEasyLoanTypeC = require('../../components/contracts/contractEasyLoanTypeC/contractEasyLoanTypeC');
const ContractEasyLoanTypeCErrorStep = require('../../components/contracts/contractEasyLoanTypeC/contractEasyLoanTypeCErrorStep/contractEasyLoanTypeCErrorStep');
const ContractEasyLoanErrorAsnef = require('../../components/contracts/contractAsnefError/contractAsnefError');
const ContractEasyLoanSidebar = require('../../components/contracts/contractEasyLoan/contractEasyLoanSidebar/contractEasyLoanSidebar');
const ContractEasyLoanTypeCSuccessStep = require('../../components/contracts/contractEasyLoanTypeC/contractEasyLoanTypeCSuccessStep/contractEasyLoanTypeCSuccessStep');
// @ CC Components
const profileActions = require('actions/profile');
const preContractualMailInfoActions = require('actions/preContractualMailInfo');

//@constants
const { WIZARD_FIRST_STEP } = require('constants/index');
//@utilities
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { recordLinkV2 } = require("utilities/tagging");
const {
    EASY_LOAN_WAFFER
} = require('constants/flagBasedFeatures');
const { catalogue, analyticsId } = require('../../components/contracts/contractAresLoan/analytics/contractAresLoanAnalytics');
const {
    easyLoanRecordStatus: { requestStatus: { PRE_APPROVAL_KO } },
    CONTRACT_EASY_LOAN_CATEGORY_EVENT
} = require('../../loansConstants/index');
const { recordEasyLoanCWizardNext, recordEasyLoanCOfferNotAvailableView } = require('../../components/contracts/contractEasyLoanTypeC/analytics/contractEasyLoanTypeC.tracking');

class ContractEasyLoanTypeCView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            displayLeaveModal: false,
            openedFromBreadcrumb: false,
            hasSetVisibleStep: false,

        };

        this.handleConfirmLeave = this.handleConfirmLeave.bind(this);
        this.onHandleSelectedAccount = this.onHandleSelectedAccount.bind(this);
        this.validateStep = this.validateStep.bind(this);
        this.leaveModalIsReady = this.leaveModalIsReady.bind(this);
        this.clearErrorsFile = this.clearErrorsFile.bind(this);
        this.setNameFile = this.setNameFile.bind(this);
        this.setVisibleStep = this.setVisibleStep.bind(this);
        this.loadFileInUpload = this.loadFileInUpload.bind(this);
        this.removeUploadedFile = this.removeUploadedFile.bind(this);
        this.goToGlobalPosition = this.goToGlobalPosition.bind(this);
    }

    componentDidMount() {
        const { immFlagBasedFeatures, getJobsInformation, getInstallmentRequest, immContractEasyLoan } = this.props;
        getJobsInformation()

        const initialValue = immContractEasyLoan.get('initialValue')
        getInstallmentRequest(initialValue)
        if (!immFlagBasedFeatures.get(EASY_LOAN_WAFFER)) {
            window.location.href = "/myprofile/loans-mortgages/";
        }
        // Position in the top of page after load
        scrollToTop();
    }

    componentDidUpdate() {
        const { immContractEasyLoanInit } = this.props;
        const easyLoanTypecIExpedient2 = immContractEasyLoanInit.get('easyLoanTypecIExpedient')
        if (easyLoanTypecIExpedient2 && !this.state.hasSetVisibleStep) {
            this.props.setVisibleStep({ visibleStep: 3 });
            this.setState({ hasSetVisibleStep: true });
        }

        if (this.props.immContractEasyLoan.get('notAvailable')) {
            this.props.history.push('/myprofile/loans-mortgages');
        }
    }
    componentWillUnmount() {
        const { resetBlockedAccounts, contractEasyLoanTypecAsnefFailureReset } = this.props;
        this.setState({
            displayLeaveModal: true
        });
        this.props.segmentedLoanProductsReset();
        resetBlockedAccounts();
        contractEasyLoanTypecAsnefFailureReset()
    }

    loadFileInUpload(uploadName, file, idx, fileLabel) {
        const receiptDefaultName = formatText("payrollLoanRequestStepThree-payrollLoanRequestStepThree_receiptDefaultName");
        const messageSnackSuccess = formatText('payrollLoanRequestStepThree-payrollLoanRequestStepThree_uploadFileSuccess');
        const response = { uploadName, file, idx, receiptDefaultName, messageSnackSuccess, fileLabel };
        this.props.loadFileInUpload({ response });
    }

    clearErrorsFile(uploadName, idx, documentId) {
        this.props.clearErrorsFile({ uploadName, idx, documentId });
    }

    removeUploadedFile(uploadName, idx, documentId) {
        this.props.removeUploadedFile({ uploadName, idx, documentId });
    }

    setVisibleStep(visibleStep) {
        this.props.setVisibleStep({ visibleStep });
    }

    setNameFile(typeFile, nameFile, idx, documentId) {
        const receiptDefaultName = formatText("payrollLoanRequestStepThree-payrollLoanRequestStepThree_receiptDefaultName");
        const response = { typeFile, nameFile, idx, documentId, receiptDefaultName };
        this.props.handlerEditFileName({ response });
    }

    onHandleSelectedAccount(accountId) {
        const { setSelectedAccount } = this.props;
        setSelectedAccount({ accountId });
    }


    validateStep(step) {
        const { validateStep, immContractEasyLoan } = this.props;
        const amount = immContractEasyLoan.get('selectedAmount') || 0;
        recordEasyLoanCWizardNext(amount);
        validateStep({ step });
    }

    buildBreadcrum() {
        return [
            {
                text: formatText('breadcrumb-loansAndMortgages'),
                url: `/myprofile/loans-mortgages`,
                onLinkClick: () => {
                    recordLinkV2(catalogue[analyticsId.CLICK_BREADCRUMB_01]());
                    this.setState({ openedFromBreadcrumb: true });
                },
            },
            {
                text: formatText('contractEasyLoanTypeC-breadcrumb')
            }
        ];
    }

    buildContent() {
        const {
            downloadINEDocument,
            downloadPreContractDocument,
            downloanEasyLoanContractDocument,
            formalize,
            getAsnefValidation,
            getBlockedAccounts,
            getHiringDocuments,
            getInstallment,
            immAccounts,
            immContractEasyLoan,
            immFlagBasedFeatures,
            immProfile,
            location,
            onDownloadDocument,
            onPrintDocument,
            preContractualMail,
            requestMinInstallmentQuantity,
            requestProfile,
            resetPrecontractualMail,
            resetStep,
            sendMail,
            setImportMaxMin,
            setLoanAmount,
            setLoanTerm,
            setPaymentDay,
            setPurpose,
            setUpStep,
            setWillCancel,
            toggleAgreeCheckbox,
            toggleTypecIneAgreeCheckbox,
            printIneDocumentStep2,
            sendEasyLoanSimpleEmail,
            setNewJobType,
            setEmploymentLevel,
            setContractType,
            setOutcome,
            loadFilesEasyLoan,
            resetUploadConfig,
            docsUploaded,
            immContractEasyLoanInit,
            getFindOutLoanInitINEContractDocuments,
            checkReadDocument,
            requestLoanApproval,
            resetStepExpedient,
            getPropositionNumber,
            checkStepThree
        } = this.props;

        const formHandlers = {
            handleJobTypeChange: setNewJobType,
            handleOutcomeChange: setOutcome,
            handleEmploymentLevelChange: setEmploymentLevel,
            handleContractTypeChange: setContractType,
        };

        const error = immContractEasyLoan.get('error');
        const errorAsnef = immContractEasyLoan.get('errorAsnef');
        const success = immContractEasyLoan.get('submitSuccessful');
        const submitSuccessfulCC = immContractEasyLoan.get('submitSuccessfulCC');

        const openingCommission = immContractEasyLoan.getIn(['openingCommission', 'amount']);
        const tin = immContractEasyLoan.get('tin');

        const selectedAccount = immContractEasyLoan.get('selectedAccount');
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);
        const loanTotalImport = immContractEasyLoan.get("totalAmount");

        let content;
        if (error) {
            content = this.buildError();
        } else if (errorAsnef) {
            content = this.buildErrorAsnef(immContractEasyLoan);
        } else if (success) {
            content = this.buildSuccess(immContractEasyLoan);
        } else if (submitSuccessfulCC) {
            window.location.href = "/myprofile/loans-mortgages/";
        } else if (immContractEasyLoan.get('stepReady')) {
            let sidebar;
            const isLoading = immContractEasyLoan.get('visibleStep') === 1 ? (immContractEasyLoan.get('isFetching') && !immContractEasyLoan.get('initialized')) : false;
            sidebar = (
                <ContractEasyLoanSidebar
                    loanTotalImport={loanTotalImport}
                    immAccount={immAccount}
                    immContractEasyLoan={immContractEasyLoan}
                    openingCommission={openingCommission}
                    tin={tin}
                    location={location}
                    isLoading={isLoading}
                />
            );

            content = (
                <div>
                    <PreLeaveModalComponent
                        acceptText={formatText('contractEasyLoanAndMortgagesTypeC-leaveModalQuit')}
                        cancelText={formatText('contractEasyLoanAndMortgagesTypeC-leaveModalContinueLater')}
                        confirmationMessage={formatText('contractEasyLoanAndMortgagesTypeC-leaveModalMessage')}
                        confirmationTitle={formatText('contractEasyLoanAndMortgagesTypeC-leaveModalTitle')}
                        isReady={this.leaveModalIsReady}
                        onContinueLater={this.onContinueLater}
                        onCancelRecord={this.onCancelRecord}
                        taggingCategoryEvent={CONTRACT_EASY_LOAN_CATEGORY_EVENT}
                    />
                    <div className="contract-easy-loan-typec-view__content-data col-xs-8">
                        <ContractEasyLoanTypeC
                            getFindOutLoanInitINEContractDocuments={getFindOutLoanInitINEContractDocuments}
                            checkReadDocument={checkReadDocument}
                            loadFileInUpload={this.loadFileInUpload}
                            removeUploadedFile={this.removeUploadedFile}
                            clearErrorsFile={this.clearErrorsFile}
                            handlerEditFileName={this.setNameFile}
                            loadFilesEasyLoan={loadFilesEasyLoan}
                            docsUploaded={docsUploaded}
                            resetUploadConfig={resetUploadConfig}
                            downloadINEDocument={downloadINEDocument}
                            downloadPreContractDocument={downloadPreContractDocument}
                            downloanEasyLoanContractDocument={downloanEasyLoanContractDocument}
                            getAsnefValidation={getAsnefValidation}
                            getBlockedAccounts={getBlockedAccounts}
                            getHiringDocuments={getHiringDocuments}
                            getInstallment={getInstallment}
                            immAccounts={immAccounts}
                            immContractEasyLoan={immContractEasyLoan}
                            immFlagBasedFeatures={immFlagBasedFeatures}
                            immProfile={immProfile}
                            onDownloadDocument={onDownloadDocument}
                            onFinish={formalize}
                            onPrintDocument={onPrintDocument}
                            preContractualMail={preContractualMail}
                            requestMinInstallmentQuantity={requestMinInstallmentQuantity}
                            requestProfile={requestProfile}
                            resetPrecontractualMail={resetPrecontractualMail}
                            resetStep={resetStep}
                            sendMail={sendMail}
                            setImportMaxMin={setImportMaxMin}
                            setLoanAmount={setLoanAmount}
                            setLoanTerm={setLoanTerm}
                            setPaymentDay={setPaymentDay}
                            setPurpose={setPurpose}
                            setSelectedAccount={this.onHandleSelectedAccount}
                            setUpStep={setUpStep}
                            setVisibleStep={this.setVisibleStep}
                            setWillCancel={setWillCancel}
                            toggleAgreeCheckbox={toggleAgreeCheckbox}
                            toggleTypecIneAgreeCheckbox={toggleTypecIneAgreeCheckbox}
                            printIneDocumentStep2={printIneDocumentStep2}
                            sendEasyLoanSimpleEmail={sendEasyLoanSimpleEmail}
                            validateStep={this.validateStep}
                            formHandlers={formHandlers}
                            immContractEasyLoanInit={immContractEasyLoanInit}
                            requestLoanApproval={requestLoanApproval}
                            resetStepExpedient={resetStepExpedient}
                            getPropositionNumber={getPropositionNumber}
                            checkStepThree={checkStepThree}
                        />
                    </div>
                    <div className="col-xs-4">
                        {sidebar}
                        <CallMeBack />
                    </div>
                </div>
            );
        } else {
            content = <LoadingSection />;
        }

        return content;
    }

    buildError() {
        const { immGlobalVariables, immContractEasyLoan } = this.props;
        const phoneNumber = immGlobalVariables.getIn(['variables', 'parameters', 'telefono', 'cliente']);
        const loanStatus = immContractEasyLoan ? immContractEasyLoan.getIn(['cirbeResponse', 'preApprovalStatus']) : null;
        let heading, message;

        if (!immContractEasyLoan || loanStatus === PRE_APPROVAL_KO) {
            heading = "contractEasyTypeCLoanError-koTitle";
            message = "contractEasyTypeCLoanError-koMessage";
        }
        else {
            heading = "contractEasyTypeCLoanError-okTitleCC";
            message = __CONTACT_CENTER__ ? "contractEasyTypeCLoanError-okMessageCC" : "contractEasyTypeCLoanError-okMessage";
        }
        return (
            <ContractEasyLoanTypeCErrorStep
                phoneNumber={phoneNumber}
                heading={heading}
                message={message}
                immContractEasyLoan={immContractEasyLoan}
                onLeave={this.props.onLeave}
                onComponentDidMountCallback={recordEasyLoanCOfferNotAvailableView}
                goToGlobalPosition={this.goToGlobalPosition}
            />
        );
    }

    buildErrorAsnef(immContractEasyLoan) {
        return (
            <ContractEasyLoanErrorAsnef
                errorValue={immContractEasyLoan.get('selectedAmount')}
                history={this.props.history}
            />
        );
    }

    buildSuccess(immContractEasyLoan) {
        return (
            <ContractEasyLoanTypeCSuccessStep
                immContractEasyLoan={immContractEasyLoan}
                onLeave={this.props.onLeave}
                goToGlobalPosition={this.goToGlobalPosition}
            />
        );
    }

    goToGlobalPosition() {
        this.props.history.push('/myprofile/global');
    }

    goToLoansPage() {
        this.props.history.push('/myprofile/loans-mortgages');
    }

    handleConfirmLeave() {
        this.props.onLeave();
    }
    onContinueLater = (step) => {
        const { saveContinueLater } = this.props;

        if (this.state.openedFromBreadcrumb) {
            this.props.history.push('/myprofile/loans-mortgages');
        } else {
            this.props.history.goBack();
        }
        saveContinueLater(step)

        this.setState({ openedFromBreadcrumb: false });
    }

    onCancelRecord = () => {
        const recordId = this.props.immPayrollLoanRecordStatus.get('recordId');
        const { cancelLoanRecord, history, resetStepExpedient } = this.props;
        cancelLoanRecord(recordId);
        resetStepExpedient()
        if (this.state.openedFromBreadcrumb) {
            history.push('/myprofile/loans-mortgages');
        } else {
            history.goBack();
        }
        this.setState({ openedFromBreadcrumb: false });
        this.props.onLeave();
    }

    leaveModalIsReady() {
        return false;
    }

    render() {
        const breadcrumb = this.buildBreadcrum();
        const title = formatText('contractEasyLoanTypeC-title');
        const content = this.buildContent();

        return (
            <article className="contract-easy-loan-typec-view">
                <OKCover size="medium" section="pg">
                    <OKHeaderSubPage
                        breadcrumbConfig={breadcrumb}
                        finalTitle={getFinalTitle(title)}
                    />
                </OKCover>
                <section className="contract-easy-loan-typec-view__body">
                    {content}
                </section>
            </article>
        );
    }
}

ContractEasyLoanTypeCView.propTypes = {
    downloadINEDocument: PropTypes.func.isRequired,
    downloadPreContractDocument: PropTypes.func.isRequired,
    downloanEasyLoanContractDocument: PropTypes.func.isRequired,
    formalize: PropTypes.func.isRequired,
    getAsnefValidation: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    getHiringDocuments: PropTypes.func.isRequired,
    getInstallment: PropTypes.func,
    getSegmentedLoanProducts: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immContractEasyLoan: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    location: PropTypes.object,
    onDownloadDocument: PropTypes.func.isRequired,
    onLeave: PropTypes.func,
    onPrintDocument: PropTypes.func.isRequired,
    preContractualMail: PropTypes.object.isRequired,
    requestMinInstallmentQuantity: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    resetStep: PropTypes.func.isRequired,
    segmentedLoanProductsReset: PropTypes.func.isRequired,
    sendMail: PropTypes.func.isRequired,
    setEasyLoanAccountsInactive: PropTypes.func.isRequired,
    setImportMaxMin: PropTypes.func,
    setLoanAmount: PropTypes.func,
    setLoanTerm: PropTypes.func,
    setPaymentDay: PropTypes.func,
    setPurpose: PropTypes.func,
    setSelectedAccount: PropTypes.func.isRequired,
    setUpStep: PropTypes.func,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func,
    toggleAgreeCheckbox: PropTypes.func.isRequired,
    toggleTypecIneAgreeCheckbox: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    getJobsInformation: PropTypes.func.isRequired,
    setEmploymentLevel: PropTypes.func.isRequired,
    setContractType: PropTypes.func.isRequired,
    getInstallmentRequest: PropTypes.func.isRequired,
    setNewJobType: PropTypes.func.isRequired,
    setOutcome: PropTypes.func.isRequired,
    loadFileInUpload: PropTypes.func.isRequired,
    removeUploadedFile: PropTypes.func.isRequired,
    clearErrorsFile: PropTypes.func.isRequired,
    resetUploadConfig: PropTypes.func.isRequired,
    handlerEditFileName: PropTypes.func.isRequired,
    loadFilesEasyLoan: PropTypes.func.isRequired,
    getLoanRecordStatus: PropTypes.func.isRequired,
    printIneDocumentStep2: PropTypes.func.isRequired,
    sendEasyLoanSimpleEmail: PropTypes.func.isRequired,
    docsUploaded: PropTypes.object.isRequired,
    cancelLoanRecord: PropTypes.func.isRequired,
    immContractEasyLoanInit: PropTypes.object,
};

ContractEasyLoanTypeCView.defaultProps = {
    immContractEasyLoan: PropTypes.object.isRequired,
    onLeave: () => { },
    setImportMaxMin: () => { },
    setWillCancel: () => { }
};

module.exports.constructor = ContractEasyLoanTypeCView;
module.exports = withRouter(connect(
    state => ({
        immAccounts: state.accounts,
        immContractEasyLoan: state.contractEasyLoanTypeC,
        immContractEasyLoanInit: state.contractInit,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immGlobalVariables: state.globalVariables,
        immProfile: state.profile,
        preContractualMail: state.preContractualMail,
        immPayrollLoanRecordStatus: state.loanRecordStatus,
    }), {
    getLoanRecordStatus: getLoanRecordStatus,
    getFindOutLoanInitINEContractDocuments: contractInit.getFindOutLoanInitINEContractDocuments,
    contractLoan: contractEasyLoanTypeC.contractLoan,
    checkReadDocument: contractEasyLoanTypeC.checkReadDocument,
    downloadINEDocument: contractEasyLoanTypeC.downloadINEDocument,
    downloadPreContractDocument: contractEasyLoanTypeC.downloadPreContractDocument,
    downloanEasyLoanContractDocument: contractEasyLoanTypeC.downloanEasyLoanContractDocument,
    formalize: contractEasyLoanTypeC.formalize,
    initialize: contractEasyLoanTypeC.initialize,
    setNewJobType: contractEasyLoanTypeC.setNewJobType,
    setEmploymentLevel: contractEasyLoanTypeC.setEmploymentLevel,
    setContractType: contractEasyLoanTypeC.setContractType,
    setOutcome: contractEasyLoanTypeC.setOutcome,
    getJobsInformation: contractEasyLoanTypeC.getJobsInformation,
    getInstallmentRequest: contractEasyLoanTypeC.getInstallmentRequest,
    getAsnefValidation: contractEasyLoanTypeC.getAsnefValidation,
    getBlockedAccounts: blockedAccountsActions.getBlockedAccounts,
    getHiringDocuments: contractEasyLoanTypeC.getHiringDocuments,
    getInstallment: contractEasyLoanTypeC.getInstallment,
    getSegmentedLoanProducts: segmentedLoanActions.getSegmentedLoanProducts,
    onDownloadDocument: contractEasyLoanTypeC.onDownloadDocument,
    onLeave: contractEasyLoanTypeC.simpleActions.contractEasyLoanTypecWillLeave,
    onPrintDocument: contractEasyLoanTypeC.onPrintDocument,
    requestMinInstallmentQuantity: contractEasyLoanTypeC.requestMinInstallmentQuantity,
    requestProfile: profileActions.requestProfile,
    resetBlockedAccounts: blockedAccountsActions.resetBlockedAccounts,
    resetPrecontractualMail: preContractualMailInfoActions.resetPrecontractualMail,
    resetStep: contractEasyLoanTypeC.simpleActions.contractEasyLoanTypecResetStep,
    segmentedLoanProductsReset: segmentedLoanActions.simpleActions.segmentedLoanProductsReset,
    sendMail: preContractualMailInfoActions.sendLoanPreContractualMail,
    setLoanAmount: contractEasyLoanTypeC.simpleActions.contractEasyLoanSetLoanAmount,
    setLoanTerm: contractEasyLoanTypeC.simpleActions.contractEasyLoanTypecSetTerm,
    setPaymentDay: contractEasyLoanTypeC.simpleActions.contractEasyLoanSetPaymentDay,
    setPurpose: contractEasyLoanTypeC.setPurpose,
    setSelectedAccount: contractEasyLoanTypeC.simpleActions.contractEasyLoanSetAccount,
    setUpStep: contractEasyLoanTypeC.setUpStep,
    setVisibleStep: contractEasyLoanTypeC.simpleActions.contractEasyLoanTypecSetStep,
    setWillCancel: contractEasyLoanTypeC.setWillCancel,
    toggleAgreeCheckbox: contractEasyLoanTypeC.simpleActions.contractEasyLoanTypecToggleAgreeCheckbox,
    validateStep: contractEasyLoanTypeC.validateStep,
    requestLoanApproval: contractEasyLoanTypeC.requestLoanApproval,
    loadFileInUpload: contractEasyLoanTypeC.uploadFilesForEasyLoan,
    removeUploadedFile: contractEasyLoanTypeC.removeFileForEasyLoan,
    clearErrorsFile: contractEasyLoanTypeC.clearErrors,
    resetUploadConfig: contractEasyLoanTypeC.simpleActions.easyLoanRequestUploadFileReset,
    handlerEditFileName: contractEasyLoanTypeC.editNameFilesForEasyLoan,
    loadFilesEasyLoan: contractEasyLoanTypeC.loadFilesEasyLoan,
    docsUploaded: contractEasyLoanTypeC.docsUploaded,
    toggleTypecIneAgreeCheckbox: contractEasyLoanTypeC.simpleActions.contractEasyLoanTypecIneToggleAgreeCheckbox,
    printIneDocumentStep2: contractEasyLoanTypeC.simpleActions.contractEasyLoanTypecPrintStep2,
    sendEasyLoanSimpleEmail: contractEasyLoanTypeC.sendEasyLoanSimpleEmail,
    cancelLoanRecord: cancelLoanRecord,
    resetStepExpedient: contractInit.resetStepExpedient,
    getPropositionNumber: contractEasyLoanTypeC.getPropositionNumber,
    checkStepThree: contractEasyLoanTypeC.checkStepThree,
    saveContinueLater: contractEasyLoanTypeC.saveContinueLater,
    contractEasyLoanTypecAsnefFailureReset: contractEasyLoanTypeC.contractEasyLoanTypecAsnefFailureReset,

}
)(ContractEasyLoanTypeCView));
